// src/pages/Clients/components/LeavePolicyTab.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Table, Popconfirm, App } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { deleteClientPolicy, fetchClients } from "../clientsSlice";
import { getDaysByValues } from "../../../lib/industries";
import { getAccessType } from "../../../lib/functions";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useIsAdminUser } from "../../../lib/accessList";


const LeavePolicyTab = ({ onEdit }) => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { clients, loading } = useSelector((s) => s.clientsSuite);

  let [access_type, access_type_set] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const authInfo = useSelector((state) => state.auth?.auth_info);
  const isAdminUser = useIsAdminUser();

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;
  const isIndia = authInfo?.country === "India";

  useEffect(() => {
    const access = getAccessType("clients_entry");
    access_type_set(access);
  }, []);

  const handleDelete = async (id) => {
    message.error("Leave Policy cannot be Deleted. Delete the client instead");
    // await dispatch(deleteClientPolicy(id));
    // message.success("Leave Policy Deleted");
    // dispatch(fetchClients());
  };

  const columns = useMemo(
    () => [
      {
        title: "Client Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: isIndia ? "Casual Leave Type" : "Annual Leave Type",
        dataIndex: "annual_leave_type",
        key: "annual_leave_type",
        render: (val) => {
          if (val === 1) return "Calendar Days";
          if (val === 2) return "Working Days";
          return "-";
        },
      },
      {
        title: isIndia ? "Casual Leave Days" : "Annual Leave Days",
        dataIndex: "annual_leave_days",
        key: "annual_leave_days",
      },
      {
        title: "Sick Leave Days",
        dataIndex: "sick_leave_days",
        key: "sick_leave_days",
        render: (v) => (v ? v : "0"),
      },
      {
        title: "Flexi Leave Days",
        dataIndex: "flexi_leave_days",
        key: "flexi_leave_days",
        render: (v) => (v ? v : "0"),
      },
      {
        title: "Weekend Days",
        dataIndex: "week_end_days",
        key: "week_end_days",
        render: (val) => {
          try {
            // handle string or array from API
            if (Array.isArray(val)) return getDaysByValues(val);
            if (typeof val === "string")
              return getDaysByValues(
                val
                  .replace(/[[\]\s]/g, "") // clean brackets/spaces
                  .split(",")
                  .map((v) => parseInt(v.trim()))
              );
            return "-";
          } catch {
            return "-";
          }
        },
      },
      {
        title: "Accrued Reset",
        dataIndex: "should_reset_accrued_leave",
        key: "should_reset_accrued_leave",
        render: (v) => (v === "yes" ? "Yes" : "No"),
      },
      {
        title: "Carry Forward",
        dataIndex: "leaves_carry_forward",
        key: "leaves_carry_forward",
        render: (v) => (v ? v : "0"),
      },
      ...(access_type === "WRITE"
        ? [
          {
            title: "Actions",
            key: "actions",
            align: "right",
            render: (_, row) => (
              <>
                <EditOutlined
                  style={{
                    marginRight: 16,
                    cursor: (isAdminUser || canEdit) ? "pointer" : "not-allowed",
                    color: (isAdminUser || canEdit) ? "#1677ff" : "#ccc",
                  }}
                  onClick={() => {
                    if (!(isAdminUser || canEdit)) return;
                    onEdit(row);
                  }}
                />
                {/* <Popconfirm
                  title="Delete Leave Policy?"
                  okText="Delete"
                  onConfirm={() => handleDelete(row.id)}
                >
                  <DeleteOutlined
                    style={{
                      cursor: "pointer",
                      color: "#ff4d4f",
                    }}
                  />
                </Popconfirm> */}
              </>
            ),
          }] : [])
    ],
    [access_type, onEdit, isIndia]
  );

  return (
    <Table
      rowKey="id"
      dataSource={clients}
      columns={columns}
      loading={loading.clients}
      scroll={{ x: "max-content" }}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: clients.length,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100],
        onChange: (page) => {
          setCurrentPage(page);
        },
        onShowSizeChange: (_, size) => {
          setPageSize(size);
          setCurrentPage(1);
        },
      }}
    />
  );
};

export default LeavePolicyTab;
